<span aria-hidden="true" [translate]="namespace + '.OLD_AGREEMENT_NASDAQ_PRE'"></span>
<a class="td-wb-padding--small td-wb-link td-wb-link--underlined"
   [attr.id]="'td-wb-agreement-old-link-NASDAQ'"
   [attr.aria-label]="(namespace + '.OLD_AGREEMENT_NASDAQ_PRE' | tdWbTranslate) + ' ' + (namespace + '.LINK_LABEL' | tdWbTranslate) + ' ' + (namespace + '.OLD_AGREEMENT_NASDAQ_POS' | tdWbTranslate)"
   tdWbHref="modal.preferences-agreements-old"
   [tdWbHrefParams]="{agreementType:'NASDAQ'}"
   [translate]="namespace + '.LINK_LABEL'"></a>
<span aria-hidden="true" [translate]="namespace + '.OLD_AGREEMENT_NASDAQ_POS'"></span>
